module.exports = __webpack_public_path__ + "static/media/esf_logo.5d738ca8.svg";